import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px 16px 16px;
    @media (min-width: 800px) {
      padding: 16px 24px 16px;
    }
    border-top: 3px solid ${colors.silver};
    margin-bottom: ${pxToRem(32)};
  `,
   disabled: css`
    opacity: 70%;
  `,
  card: css`
    min-width: auto;
    height: ${pxToRem(24)};
    margin: 5px;
    gap: 4px;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    background: ${colors.platinum};
    border: 1px solid ${colors.prussian400};
    border-radius: ${pxToRem(10)};
    cursor: pointer;
  `,
  text: css`
    font-size: ${pxToRem(12)};
    line-height: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    color: ${colors.prussian};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  icon: css`
    margin-right: 3px;
  `,
  categoryList: css`
    display: flex;
    padding-top: 16px;
  `,
};

export default styles;
